import copy from "clipboard-copy";
import { Location } from "vue-router";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { ThumbnailOptions } from "@scrile/tools/dist/lib/MediaFilesController";
import { IS_BROWSER, isMobile } from "@/lib/browserUtils";
import emitter from "@/lib/emitter";
import { FileType, isImageFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import { EVENTS } from "@/const";

declare type Resolutions = "240p" | "360p" | "480p" | "720p" | "1080p";

export function getAbsUrl(url: string) {
  return `${IS_BROWSER ? window.location.origin : ""}${url}`;
}
export function getProfileUrl(
  user: UserPublicData | User | string,
  { feedId }: { feedId?: string } = {},
  { tab }: { tab?: string } = {}
): Location {
  return {
    name: typeof user !== "string" ? "profile" : "profileById",
    params: {
      ...(typeof user !== "string" ? { username: user.username ?? "", userId: user.id } : { userId: user }),
    },
    ...{ query: { feedId, tab } },
  };
}

export function getMassMessageUrl(groupIds: string[]): Location {
  return { name: "massMessage", params: { ids: groupIds.join(",") } };
}

export const LOGO_URL = config.publicS3Url + "/logo";

export function getLiveUrl(user: UserPublicData | User): Location {
  return {
    name: "profile/live",
    params: {
      username: user.username,
    },
  };
}

export async function shareUrl(url: string, notificationText?: string) {
  const useCopy = async (url: string, notificationText?: string) => {
    await copy(url);
    notificationText && emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: notificationText });
  };
  /* eslint-disable @typescript-eslint/ban-ts-ignore */
  // @ts-ignore
  if (isMobile() && navigator.share) {
    /* eslint-disable @typescript-eslint/ban-ts-ignore */
    // @ts-ignore
    return navigator.share({ url }).catch(() => useCopy(url, notificationText));
  } else return useCopy(url, notificationText);
}

export const getMediaThumbnailUrl = (
  file: FileType,
  urlPart: string,
  width: Resolutions | "auto" | number = "240p",
  height?: "auto" | number,
  opts?: ThumbnailOptions
): string => {
  return isImageFile(file)
    ? MediaFilesController.getImageThumbnail(urlPart, width, height, opts)
    : MediaFilesController.getVideoThumbnail(urlPart, width, height, opts);
};

export const getExternalUrl = (url: string) =>
  url.match(/((http(s)?:\/\/)|((tel)|(mailto):)).*/gim) ? url : `https://${url}`;
